var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 296,
    viewBox: "0 0 300 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_1052)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 296,
    fill: "#EAECE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4681 0.220215C34.7292 0.220215 0 39.1091 0 87.1235V175.22H78.5319C121.271 175.22 156 136.331 156 88.3871V87.1235C156 39.1793 121.333 0.220215 78.5319 0.220215H77.4055H77.4681Z",
    fill: "#358273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.532 0.220215H250.468C207.684 0.220215 173 39.1282 173 87.1236V88.3169C173 136.312 207.684 175.22 250.468 175.22H251.532C294.316 175.22 329 136.312 329 88.3169V87.1236C329 39.1282 294.316 0.220215 251.532 0.220215Z",
    fill: "#FF958C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5945 180.22H77.4055C34.6556 180.22 0 219.319 0 267.55V268.891C0 317.122 34.6556 356.22 77.4055 356.22H78.5945C121.344 356.22 156 317.122 156 268.891V267.55C156 219.319 121.344 180.22 78.5945 180.22Z",
    fill: "#92D1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.063 267.62C173.063 219.402 207.715 180.22 250.5 180.22H329V268.82C329 317.039 294.347 356.22 251.563 356.22H250.437C207.715 356.22 173 317.109 173 268.82V267.55L173.063 267.62Z",
    fill: "#00008E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_1052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 296,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.a681395c3455a670037de74c198d8acb.svg";
export { ForwardRef as ReactComponent };